import { EORDER_STATUS } from "@constants";
import { makeStyles } from "tss-react/mui";
import { getOrderStatusColor } from "./utils";
interface IParams {
    orderStatus: EORDER_STATUS;
}

export const useStyle = makeStyles<IParams>()((theme, { orderStatus }) => ({
    chip: {
        backgroundColor: getOrderStatusColor(orderStatus, theme),
        color: theme.palette.primary.contrastText,
        width: "fit-content",
        height: "fit-content",
        padding: theme.spacing(0.5, 1),
        "& .MuiChip-label": {
            padding: 0,
        },
    },
}));
